import React, { Component } from "react";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import ArrowRightIcon from '@mui/icons-material/ArrowRight';
import { ownStore } from "../../../AppOwnState/ownState";

class FactsGlobalSearchField extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: "",
      inputValue: "",
      searchFieldColor: "#FFFFFF33",
      searchFieldTextColor: "#FFFFFF",
    };

    this.unsubscribe = ownStore.subscribe((storeInfo) => {
      let storeDset = storeInfo.dset;
      if (storeDset === "dsAppTheme") {
        let dsAppTheme = ownStore.getState("dsAppTheme");
        if (dsAppTheme) {
          this.setState({
            searchFieldColor: dsAppTheme?.searchFieldColor,
            searchFieldTextColor: dsAppTheme?.searchFieldTextColor,
          });
        }
      }
    });
  }

  componentWillUnmount() {
    this.unsubscribe();
  }

  handleChange = (event, value) => {
    let menuItem = {};
    if (value != null) {
      for (let i = 0; i < this.props.userMenu.length; i++) {
        if (this.props.userMenu[i].caption === value.caption) {
          menuItem = this.props.userMenu[i];
          break;
        }
      }
      this.props.menuDropClick(menuItem, null, null);
    }

    this.setState({
      value: "",
    });
  };

  handleInputChange = (event, value) => {
    this.setState({
      inputValue: value,
    });
  };

  handleClose = () => {
    this.setState({
      inputValue: "",
    });
  };

  render() {
    return (
      <React.Fragment>
        <Stack
          className="factsGlobalSearchField"
          spacing={2}
          sx={{ width: 200 }}
          style={{ margin: "0px", padding: "0px" }}
        >
          <Autocomplete
          autoHighlight
            className="factsGlobalSearchFieldAutocomplete"
            id="free-solo-search"
            freeSolo
            disableClearable
            options={this.props.userMenu.filter((menu) => menu.action)}
            getOptionLabel={(option) =>
              option.caption ? `${option.caption} (${option.doctype})` : ""
            }
            renderOption={(props, option, { selected }) => (
              <li
                {...props}
                key={option.menuid}
                // className={`globalSearchLi ${selected && 'selectedSearchLi'}`}
                style={{
                  fontSize: '12px',
                  display: 'flex',
                  alignItems: 'center',
                  padding: '4px 8px', // Add padding for a better visual effect
                }}
              >
                <ArrowRightIcon sx={{ marginRight: 1 }} />
                {option.caption} - {option.doctype}
              </li>
            )}
            renderInput={(params) => (
              <TextField
                {...params}
                placeholder="Search here..."
                InputProps={{
                  ...params.InputProps,
                  type: "search",
                  className: "factsGlobalSearchFieldInput",
                }}
                className="factsGlobalSearchFieldText"
              />
            )}
            onChange={this.handleChange}
            onClose={this.handleClose}
            onInputChange={this.handleInputChange}
            size="small"
            clearOnBlur={true}
            value={this.state.value}
            inputValue={this.state.inputValue}
          />
        </Stack>
      </React.Fragment>
    );
  }
}

export default FactsGlobalSearchField;
